import { useTranslator } from '@bluebeam/react-i18n';
import BasicBlueprint from 'components/Icons/BasicBlueprint';
import EmptyState from 'components/Icons/EmptyState';
import SheetTile from 'components/SheetTile';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Sheet } from 'records/Sheet';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps, RouteComponentProps {
  onViewAllClicked: (projectId: string) => void;
  onSheetClicked: (sheetId: string) => void;
}

const Drawings: React.FC<Props> = (props: Props) => {
  const { history, appState, onViewAllClicked, onSheetClicked } = props;
  const { projects, selectedProject } = appState;
  const { translate } = useTranslator(['roverDashboard']);

  const handleUploadClick = (): void => {
    history.push(`/project/${selectedProject}/drawings/published`);
  };

  const sheets = appState.sheets.take(5);
  const project = projects.get(selectedProject);
  const canUpload = project?.permissions.managePeople;

  return (
    <div id="dashboard-drawings-card" className="column w100 h100">
      <div className="row justify-between mb2 shrink-0">
        <div className="medium flex items-center font-size-5 color-gray-7">
          <div className="wrem-1p5 hrem-1p5 mr1 icon flex-center fill-primary-blue">
            <BasicBlueprint width="18px" height="15px" />
          </div>
          <div>{translate('roverDashboard:drawings')}</div>
        </div>
        {sheets.size > 0 ? (
          <div className="bold font-size-5 justify-center">
            <button
              id="dashboard-drawings-card-view-all-btn"
              className="btn-sm btn-link"
              onClick={(): void => {
                onViewAllClicked(selectedProject);
              }}
            >
              <span className="color-gray-7 font-size-2">
                {translate('roverDashboard:viewAll')}
              </span>
            </button>
          </div>
        ) : null}
      </div>
      <div className="oxa bgd-section b-radius-3 h100 p3 mb5">
        {sheets.size > 0 ? (
          <div className="column">
            <div className="row" style={{ minWidth: '172px' }}>
              {sheets
                .map((s: Sheet) => (
                  <div
                    key={s.sheetid}
                    style={{
                      width: '173px',
                      height: '172px',
                      minWidth: '173px',
                      minHeight: '172px',
                    }}
                    className="mr3"
                  >
                    <SheetTile
                      selected={false}
                      key={s.sheetid}
                      sheet={s}
                      onSheetClick={(sheet: Sheet): void => {
                        onSheetClicked(sheet.sheetid);
                      }}
                    />
                  </div>
                ))
                .valueSeq()}
            </div>
          </div>
        ) : (
          <div className="grow-1 flex-center h100" style={{ height: '172px' }}>
            {canUpload ? (
              <div className="flex items-center">
                <button
                  id="dashboard-drawings-card-upload-btn"
                  className="btn-sm btn-primary"
                  onClick={handleUploadClick}
                >
                  {translate('roverDashboard:uploadDrawings')}
                </button>
              </div>
            ) : (
              <div className="column justify-center items-center">
                <div className="mb3 fill-gray-5">
                  <EmptyState width="64px" height="64px" />
                </div>
                <div className="font-size-4 bold color-gray-9 mb2">
                  {translate('roverDashboard:noDrawings')}
                </div>
                <div className="font-size-4 color-gray-9 mb2">
                  {translate('roverDashboard:adminUploadMsg')}
                </div>
              </div>
            )}

            <div />
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(withAppStore<Props>(Drawings));
